import React from "react"
import {FieldAutomationTriggerFormProps} from "../../../../render/automation-trigger-form";
import SelectMultiGenericNew from "../../../../../gd-ui/select-multi-generic-new/select-multi-generic-new";

const debug = false
 // const debug = "DropdownTriggerForm"

 export default class FieldDropdown_AutomationTriggerForm extends React.Component<FieldAutomationTriggerFormProps,any> {

     // static propTypes = {
     //     config          : PropTypes.object,
     //
     //     options         : PropTypes.array,
     //
     //     onChangeCallback: PropTypes.func,
     // }

     constructor(props:FieldAutomationTriggerFormProps) {
         super(props)

         this.state = {
             fromValue       : _.get(props.config, 'fromValue', null),
             toValue         : _.get(props.config, 'toValue', null)
         }
     }

     onChangeFromValues = (fromValue:any) => {
         this.setState({
             fromValue
         }, ()=>{
             this.props.onChangeCallback({fromValue})
         })
     }

     onChangeToValues = (toValue:any) => {
         this.setState({
             toValue
         }, ()=>{
             this.props.onChangeCallback({toValue})
         })
     }

     render() {
         debug && console.log(debug, 'render', this.state)

         return (
             <div className="flex-row-left-top">
                 <div className="label">from</div>
                 <SelectMultiGenericNew className                        = "selector w-180"
                                        options                          = {this.props.field.getAutomationOptions()}
                                        values                           = {this.state.fromValue}
                                        allValuesOptionLabel             = "Any"
                                        popoverScrollContainerClasses    = "max-h-200"
                                        allValuesOption                  = {true}
                                        isSearchable                     = {true}
                                        disabled                         = {this.props.config.disabled}
                                        onChange                         = {this.onChangeFromValues}/>

                 <div className="label">to</div>
                 <SelectMultiGenericNew className                        = "selector w-180"
                                        options                          = {this.props.field.getAutomationOptions()}
                                        values                           = {this.state.toValue}
                                        allValuesOptionLabel             = "Any"
                                        popoverScrollContainerClasses    = "max-h-200"
                                        allValuesOption                  = {true}
                                        isSearchable                     = {true}
                                        disabled                         = {this.props.config.disabled}
                                        onChange                         = {this.onChangeToValues}/>
             </div>
         )
     }

 }


